/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbListCmdbClassResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbListCmdbClassResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbListCmdbClassResponse>): ServiceNowCmdbListCmdbClassResponse {
        let obj = Object.assign(new ServiceNowCmdbListCmdbClassResponse(), model);
        ServiceNowCmdbListCmdbClassResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbListCmdbClassResponse>): ServiceNowCmdbListCmdbClassResponse {
        if (!model) return null;
        return ServiceNowCmdbListCmdbClassResponse.newInstance(<ServiceNowCmdbListCmdbClassResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbListCmdbClassResponse) {
        if (!obj) return;

        models.ServiceNowCmdbListCmdbClassResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbListCmdbClassResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbListCmdbClassResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.ServiceNowCmdbCiClass.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Cmdb CI Classes
     */
    results: Array<models.ServiceNowCmdbCiClass>;

}
